import { SelectableProductAccount } from '../../../query-api'

export const getDisplayTitle = (account: SelectableProductAccount) =>
  account.accountNo ? `${account.accountNo} - ${account.name}` : account.name
